import axios from './../../config/axios';

function search(query) {
    return axios().get("/sales/dimensions-search", {
        params: {
            search: query
        }
    })
}

export default {
    search
}